<!-- WebDDN Cart Flyout — semantic <aside> landmark -->
<aside id="nav-flyout-webddncart"
  class="nav-webddncart-lazy-align nav-webddncartFlyout nav-flyout nav-locked nav-flyout-webddncart-compact"
  [class.open]="isOpen()" aria-label="Shopping cart" role="complementary">
  <!-- <div class="top-ban-bar">sss</div> -->

  <div class="nav-flyout-body webddncart-beacon" tabindex="-1">
    <div class="nav-webddncart-content">
      <div class="webddncart-compact" id="webddncart-content">
        <!-- Flyout Top Close Button -->
        <!-- <div class="webddncart-top-bar">
          <button type="button" class="webddncart-close-button" (click)="close()" title="Close cart"
            aria-label="Close cart flyout">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" class="webddncart-close-svg">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div> -->

        <!-- Subtotal Head -->
        <div class="a-row webddncart-head">
          <input type="hidden" name="totalCartQuantity" [value]="cartItemCount()" id="webddncart-total-quantity" />
          <div class="a-row webddncart-view-cart-header">
            <div data-cart-type="Retail_Cart"
              class="a-row webddncart-cart-header webddncart-cart-header--selected webddncart-subtotal">
              <span>
                <div class="subtotal-group">
                  <div class="a-size-small a-color-base subtotal-heading webddncart-subtotal-label"
                    style="display:inline-block; margin-right:4px;">Subtotal</div>

                  <div
                    class="a-size-base a-color-price a-text-bold webddncart-subtotal-amount webddncart-subtotal-value"
                    style="display:inline-block;">
                    {{ cartSubtotal() | centsToCurrency }}
                  </div>
                </div>
              </span>
              <span class="a-size-mini a-color-secondary webddncart-subtotal-qty"
                style="display:inline-block; margin-left:4px;">({{ cartItemCount() }} {{ cartItemCount() === 1 ? 'item'
                : 'items' }})</span>
            </div>
          </div>
        </div>

        <!-- Compact Actions (Go to cart / Checkout) -->
        <div id="webddncart-actions-container" class="a-section a-spacing-none webddncart-wider-compact-view-only">
          <div data-cart-type="Retail_Cart" class="a-row webddncart-actions webddncart-actions--selected">
            <div id="webddncart-cart-button" class="a-row webddncart-go-to-cart">
              <span class="a-button a-button-base a-button-small webddncart-cart-btn-span">
                <span class="a-button-inner">
                  <a [routerLink]="'/shop/cart'" (click)="close()" class="a-button-text">
                    Go to cart
                  </a>
                </span>
              </span>
              <span class="a-button a-button-primary a-button-small webddncart-checkout-btn-span">
                <span class="a-button-inner">
                  <a (click)="proceedToCheckout()" (keydown.enter)="proceedToCheckout()" class="a-button-text"
                    role="button" tabindex="0">
                    {{ checkoutButtonLabel() }}
                  </a>
                </span>
              </span>
            </div>
            @if (hasRegistrationItem() && !isUserSignedIn()) {
            <div class="a-row text-center mt-1" style="font-size: 11px; padding-top: 4px;">
              <span>Parent registration required for team items</span>
            </div>
            }
          </div>
        </div>

        <div class="a-row a-spacing-small webddncart-item-separator"></div>

        <!-- Scrollable Item List -->
        <div id="webddncart-body">
          <div class="a-scroller webddncart-scroller webddncart-scroller--selected a-scroller-vertical">
            <div data-cart-type="Retail_Cart" class="a-row webddncart-active-cart webddncart-active-cart--selected">
              @if (cartItems().length === 0) {
              <div class="webddncart-empty-cart">
                <p>Cart is empty</p>
                <a [routerLink]="'/shop/explore'" (click)="close()" class="webddncart-browse-link">Browse products</a>
              </div>
              } @else {
              <ul class="a-unordered-list a-nostyle a-vertical" role="list">
                @for (item of cartItems(); track item.product.products_id) {
                <li>
                  <span class="a-list-item">
                    <div class="a-row webddncart-item">
                      <div class="a-section a-spacing-none webddncart-item-content webddncart-item-update-content">
                        <div class="a-row webddncart-item-image">
                          <a class="a-link-normal sc-product-link"
                            [routerLink]="['/shop/product', item.product.products_id]" (click)="close()"
                            [title]="item.product.products_name">
                            <img [src]="resolvedCartImage(item.product.products_image)"
                              alt="{{ item.product.products_name }}" title="{{ item.product.products_name }}"
                              class="sc-product-image" width="76" height="76" />
                          </a>
                        </div>
                        <span class="webddncart-unit-price webddncart-wider-compact-view-only">
                          <span class="a-size-base a-text-bold">
                            {{ (+item.product.products_price * item.quantity) | centsToCurrency }}
                          </span>
                        </span>
                      </div>

                      <div class="a-row webddncart-qty-and-action-items">
                        <div class="quantity-dropdown">
                          @if (isProductType4(item.product)) {
                          <div class="webddn-team-action-container">

                            <span class="webddn-team-label webddn_team-label">
                              <button type="button" class="webddncart-remove-btn"
                                (click)="removeItem(item.product.products_id)" title="Remove item"
                                aria-label="Remove item">
                                <svg class="webddncart-stepper-trash-svg" viewBox="0 0 24 24" fill="none"
                                  stroke="currentColor" stroke-width="2">
                                  <polyline points="3 6 5 6 21 6"></polyline>
                                  <path
                                    d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2">
                                  </path>
                                </svg>
                              </button>
                              {{ (webddn_team || 'team') | titlecase }}
                            </span>

                          </div>
                          } @else {
                          <span class="sc-action-quantity">
                            <span class="sc-quantity-stepper">
                              <div class="a-stepper-inner-container">
                                <div class="a-stepper-controls">
                                  <button type="button" class="a-stepper-btn decrement"
                                    (click)="updateCartQuantity(item.product.products_id, item.quantity - 1)"
                                    [attr.aria-label]="item.quantity <= 1 ? 'Delete item' : 'Decrease quantity'">
                                    @if (item.quantity <= 1) { <svg class="webddncart-stepper-trash-svg"
                                      viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                      <polyline points="3 6 5 6 21 6"></polyline>
                                      <path
                                        d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2">
                                      </path>
                                      </svg>
                                      } @else {
                                      <span class="stepper-symbol">−</span>
                                      }
                                  </button>
                                  <div class="a-stepper-spinbutton">
                                    <span class="a-stepper-value">{{ item.quantity }}</span>
                                  </div>
                                  <button type="button" class="a-stepper-btn increment"
                                    (click)="updateCartQuantity(item.product.products_id, item.quantity + 1)"
                                    aria-label="Increase quantity">
                                    <span class="stepper-symbol">+</span>
                                  </button>
                                </div>
                              </div>
                            </span>
                          </span>
                          }
                        </div>
                      </div>

                      <div class="a-row webddncart-item-separator"></div>
                    </div>
                  </span>
                </li>
                }
              </ul>
              }
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</aside>